module.exports = __webpack_public_path__ + "img/header.e8b6d099.jpg";